import React from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Tenía ataques de pánico en el trabajo. En el baño, con auriculares y el protocolo del Tomo 1, logré calmarme en 5 minutos antes de una presentación importante. Nadie se dio cuenta.',
    author: 'Luciana T.',
    location: 'Abogada · Buenos Aires',
    initial: 'L'
  }, {
    quote: 'Dormía 7 horas y me levantaba destruida. El kinesiólogo me dijo que era estrés. Empecé el ritual nocturno del Tomo 2. En 10 días mis colegas me preguntaron si había tomado vacaciones. No las había tomado.',
    author: 'Florencia M.',
    location: 'Médica · Córdoba',
    initial: 'F'
  }, {
    quote: 'Soy desarrollador y trabajaba en modo reactivo todo el día. Con el Gamma 40 Hz y los bloques del Tomo 3 empecé a hacer más trabajo real en 2 horas que antes en 8. Los números no mienten.',
    author: 'Tomás R.',
    location: 'Dev Full Stack · Buenos Aires',
    initial: 'T'
  }, {
    quote: 'Después de una separación muy difícil, la casa se sentía terrible. Hice la limpieza vibracional del Tomo 4 un sábado solo. Mi mejor amiga vino el domingo y me preguntó si había pintado. No había pintado nada.',
    author: 'Patricia S.',
    location: 'Psicóloga · Rosario',
    initial: 'P'
  }, {
    quote: 'Tenía contractura cervical hace 2 años. Ningún kinesiólogo la resolvía del todo. El protocolo de 174 Hz del Tomo 5 en dos semanas hizo más que 12 sesiones de kinesiología.',
    author: 'Diego C.',
    location: 'Contador · Mendoza',
    initial: 'D'
  }, {
    quote: 'Lo usé con mis hijos de 4 y 8 años. El de 4 tardaba 2 horas en dormirse. Con el protocolo del Bono 4, en una semana se dormía en 20 minutos. Fue un antes y un después para toda la familia.',
    author: 'Marcela V.',
    location: 'Mamá y emprendedora · GBA',
    initial: 'M'
  }];
  const Stars = () => <div className="flex gap-1 md:gap-1.5 text-[#7c3aed] mb-3 md:mb-6" data-id="element-426">
      {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" className="drop-shadow-[0_0_5px_rgba(124,58,237,0.3)] w-4 h-4 md:w-5 md:h-5" data-id="element-427" />)}
    </div>;
  return <section className="py-8 md:py-20 px-4 max-w-6xl mx-auto bg-[#faf7f2]" data-id="element-428">
      <FadeIn data-id="element-429">
        <h2 className="text-2xl md:text-5xl font-black text-[#1f1b16] text-center mb-6 md:mb-14 flex items-center justify-center gap-2 md:gap-4 px-2" data-id="element-430">
          <span className="text-[#ef4444] drop-shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-431">
            ❤️
          </span>{' '}
          LO QUE DICEN LOS QUE YA LO TIENEN
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-432">
        {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-433">
            <motion.div whileHover={{
          y: -5
        }} className="bg-[#faf7f2] border border-[#e7dfce] hover:border-[#7c3aed]/50 rounded-2xl md:rounded-3xl p-5 md:p-8 h-full relative overflow-hidden shadow-sm hover:shadow-md transition-all" data-id="element-434">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-[#f5efe4] w-16 h-16 md:w-24 md:h-24 rotate-180 -z-0" data-id="element-435" />

              <div className="relative z-10 flex flex-col h-full" data-id="element-436">
                <Stars data-id="element-437" />
                <p className="text-base md:text-xl text-[#1f1b16] mb-4 md:mb-8 italic leading-relaxed font-medium flex-grow" data-id="element-438">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 md:gap-4 mt-auto pt-4 md:pt-6 border-t border-[#e7dfce]" data-id="element-439">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#7c3aed] to-[#a78bfa] rounded-full flex items-center justify-center text-[#0f0d09] font-black text-base md:text-xl shadow-[0_5px_15px_rgba(124,58,237,0.3)]" data-id="element-440">
                    {t.initial}
                  </div>
                  <div data-id="element-441">
                    <p className="font-black text-[#1f1b16] text-base md:text-lg" data-id="element-442">
                      {t.author}
                    </p>
                    <p className="text-xs md:text-sm text-[#6b6358] font-bold" data-id="element-443">
                      {t.location}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}